/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import { Provider } from "react-redux";
import { store } from "./auth/store";
import { Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import Home from "./pages/home";
import DashboardPg from "./stats/cst";
import DashboardPg2 from "./stats/dashboard2";
import CrCST from "./stats/cst";
import LoginPg from "./auth/login";
import VerifyPg from "./auth/verify";
import SignupPg from "./auth/signup";
import ForgotPg from "./auth/forgot";
import ResetpPg from "./auth/resetp";
import "./utils/inject";
import UsersGraph from "./pages/usersGraph";
import Dialog from "./components/Dialog";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./components/layout";
import NewPage from "./pages/NewPage";
import LocationGrahp from "./pages/LocationGraph";
import LocationDialog from "./components/LocationDialog";
import InterrogationList from "./pages/InterrogationList";
import ExportList from "./pages/ExportList";
import "./App.css";
import "./styles/normalize.css";
import "./styles/styles2.css";
import "./styles/styles.css";
import "./styles/styles3.css";
import "./styles/customize.css";
import "react-datepicker/dist/react-datepicker.css";
import MFRUploadDialog from "./components/MFRUploadDialog";
import FullPageLoading from "./components/FullPageLoading";
import AnalyticsDevice from "./pages/analytics-device";
import Patients from "./pages/patients";
import PatientsList from "./pages/PatientsList";
import PatientEnrollment from "./pages/PatientsList/PatientEnrollment";
import LocationsList from "./pages/LocationsList";
import Locations from "./pages/locations";
import UsersList from "./pages/UsersList";
import PreAuthList from "./pages/PreathList";
import NewDevice from "./stats/newDevice";
import EnabledDevice from "./pages/enabled-device";
import UnsignedStat from "./stats/unsignedStat";
import MissedAndDueList from "./pages/MissedAndDueList";

const LayoutRoute = (props) => (
  <Layout>
    <Route {...props} />
  </Layout>
);

function App() {
  return (
    <FullPageLoading>
      <MFRUploadDialog>
        <LocationDialog>
          <Dialog>
            <Provider store={store}>
              <ToastProvider placement="top-center" autoDismiss={true}>
                <BrowserRouter>
                  <Switch>
                    <Route
                      exact
                      path="/(dashboard3|analytics3|auth/logout|home|)"
                      render={() => (localStorage.getItem("genToken") ? null : <Redirect to="/auth/login" />)}
                    />
                    <Route path="/auth/login">
                      <LoginPg />
                    </Route>
                    <Route path="/auth/verify">
                      <VerifyPg />
                    </Route>
                    <Route path="/auth/forgot/:c([a-z0-9]{26})/:m([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|[A-Z0-9]{5,})">
                      <ResetpPg />
                    </Route>
                    <Route path="/auth/forgot">
                      <ForgotPg />
                    </Route>
                    <Route path="/auth/signup/:c([a-z0-9]{26})/:m([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|[A-Z0-9]{5,})">
                      <SignupPg />
                    </Route>
                    <LayoutRoute path="/" exact>
                      <Home />
                    </LayoutRoute>
                    <LayoutRoute path="/reports3/due" component={MissedAndDueList} />
                    <LayoutRoute path="/reports3/missed" component={MissedAndDueList} />
                    <LayoutRoute path="/reports3/patientengagement" component={MissedAndDueList} />
                    <LayoutRoute path="/reports3/preauth/:tab?" component={PreAuthList} />
                    <LayoutRoute path="/reports3/:tab?" component={InterrogationList} />
                    <LayoutRoute path="/billing3/export/:tab?" component={ExportList} />
                    <LayoutRoute path="/analytics3/cst" component={CrCST} />
                    <LayoutRoute path="/analytics3/device" component={AnalyticsDevice} />
                    <LayoutRoute path="/analytics3/newdev" component={NewDevice} />
                    <LayoutRoute path="/analytics3/unsigned" component={UnsignedStat} />
                    <LayoutRoute path="/analytics3/enabled" component={EnabledDevice} />
                    <LayoutRoute path="/analytics3/service" exact component={UsersGraph} />
                    <LayoutRoute path="/analytics3/events" exact component={LocationGrahp} />
                    <LayoutRoute path="/dashboard3/:i([0-9]{1,})" component={DashboardPg2} />
                    <LayoutRoute path="/dashboard2/:i([0-9]{10})" exact component={DashboardPg} />
                    <LayoutRoute path="/analytics3/hubmgr" exact component={NewPage} />
                    <LayoutRoute path="/patients3/enrollment" component={PatientEnrollment} />
                    <LayoutRoute path="/patients3/:i([0-9]{3,})" component={Patients} />
                    <LayoutRoute path="/patients3/:tab?" component={PatientsList} />
                    <LayoutRoute path="/users3/:tab?" component={UsersList} />
                    <LayoutRoute path="/locations3/:i([0-9]{1,})" component={Locations} />
                    <LayoutRoute path="/locations3/:tab?" component={LocationsList} />
                    <LayoutRoute path="/interrogations" component={Patients} />
                  </Switch>
                </BrowserRouter>
              </ToastProvider>
            </Provider>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Dialog>
        </LocationDialog>
      </MFRUploadDialog>
    </FullPageLoading>
  );
}

export default App;
